import { Icon } from '@dynamic/ui';
import styled from 'styled-components';

import { handleOpacity, remify } from '#/service/utils';

import { focusShadow, transformEaseFunction } from '../common';

export const AccordionTrigger = styled.div`
  box-sizing: border-box;
  cursor: pointer;
  color: inherit;
  padding: 0;
  background: none;
  border: none;
  display: flex;
  width: 100%;
  min-height: ${remify(53)};
  align-items: center;
  outline: none;

  &.focus-visible {
    ${focusShadow}
  }
`;

export const AccordionContainer = styled.div`
  .Collapsible {
    box-shadow: none;
    border-bottom: 1px solid
      ${({ theme }) =>
        handleOpacity(theme.color.pageSecondaryBackground, 0.2) ||
        'rgba(255, 255, 255, 0.2)'};
    padding: 0 ${remify(50)};
    background-color: transparent;
    color: var(--pageHeadingForeground);
  }
`;

export const AccordionTitle = styled.div`
  flex-grow: 1;
  text-align: left;
  font: var(--fontStyleTitle);
  margin: ${remify(12)} 0;
  display: block;
`;

export const ArrowIcon = styled(Icon)`
  color: var(--pageParagraphForeground);
`;

export const IconContainer = styled.div<{ $open: boolean }>`
  display: flex;
  padding: ${remify(12)};
  margin-right: ${remify(-12)};
  transform: rotate(0deg);
  transition: transform 150ms ${transformEaseFunction};
  ${({ $open }) => $open && `transform: rotate(180deg);`}
`;
